import node_env from "../node_env";
import {getCookie} from "../utils/common";
import axios from "axios";
import qs from "qs";

let preUrl = 'https://11-app-mop.smartz.cloud' //'/web'

if(node_env === 'production'){
  preUrl = 'https://11-app-mop.smartz.cloud'
}

// 提交数据
function postEvent(data){
  let _tokenid = getCookie('token');
  let _platform = 21;

  let req  = {
    callback: `Query321009757855893705947_${new Date().getTime()}`,
    token   : _tokenid, // token
    platform: _platform, // 平台
    code: data.code, // code
    client  : 3, // 1: 苹果 2: 安卓 3: web pc, 31: web 苹果  32: web 安卓
    page : data.page,  // 页面名称
    event: data.event, // 事件 1 加载页面，2 点击事件
    params: JSON.stringify({other: data.other}),
  };

  let _url = `${preUrl}/stat/click_stat?${qs.stringify(req)}`;

  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }

  axios.get(_url, {headers}).then((res) => {

  }).catch(e => {
    console.log(e);
  }).finally(() => {
    if(data.url){
      window.location.href = data.url;
    }
  })

}

// 整理数据


// 点击事件
export function mouseClickEvent(obj){
  obj.event = 2;
  postEvent(obj);
}

// 加载事件
export function pageLoadEvent(obj){
  obj.event = 1;
  postEvent(obj);
}



// WEBPACK FOOTER //
// ./src/api/submitEvent.js